module.exports = __webpack_public_path__ + "static/media/padlock-light.745b0d99.svg";